<template>
  <DialogBase
    ref="dialogBase"
    :title="$gt('Privatsphäre-Einstellungen')"
    iconType="shield"
    :onCancel="declineCookies"
    :onAction="acceptCookies"
    cancelButtonText="Ablehnen"
    actionButtonText="Akzeptieren"
  >
    <template v-slot:content>
      <!-- Feedback 08.08.26, I.1: "Da fehlt das Leerzeichen."
           Ursache war der Whitespace zwischen <span> und <router-link> – in
           einem Flex-Container werden reine Whitespace-Textknoten verworfen.
           Deshalb steht der Link jetzt im selben Textfluss, getrennt durch ein
           geschuetztes Leerzeichen. -->
      <span>
        {{ $gt('Wir verwenden ausschließlich technisch notwendige Cookies (z.B. zur Sitzungsverwaltung), um den Betrieb dieser Anwendung sicherzustellen. Weitere Informationen finden Sie in unserer') }}&nbsp;<router-link
          :to="{ name: 'PagePrivacyPolicy' }"
          class="custom-link"
          target="_blank"
          rel="noopener noreferrer"
        >{{ $gt('Datenschutzerklärung') }}</router-link>.
      </span>
    </template>
  </DialogBase>
</template>

<script>
import DialogBase from "@/components/windows/dialogs/DialogBase.vue";

export default {
  name: "DialogCookeWarning",

  components: {
    DialogBase,
  },

  mounted() {
    this.checkCookieConsent();
  },

  methods: {
    checkCookieConsent() {
      if (!localStorage.getItem("cookieConsent")) {
        this.$refs.dialogBase.openDialog();
      }
    },

    acceptCookies() {
      localStorage.setItem("cookieConsent", "accepted");
      this.$refs.dialogBase.closeDialog();
    },

    declineCookies() {
      localStorage.setItem("cookieConsent", "declined");
      this.$refs.dialogBase.closeDialog();
    },
  },
};
</script>
